<div class="renewal-container">
  @if (!isDeletingAccount) {
    <div class="renewal-card">
      <mat-icon class="subscription-icon">card_membership</mat-icon>
      <h2>Rinnova il tuo abbonamento</h2>
      <p>
        Il tuo abbonamento è scaduto. Rinnova ora per continuare a utilizzare
        PsicoGenius.
      </p>
      <div class="benefits-list">
        @for (benefit of benefits; track benefit) {
          <div class="benefit-item">
            <mat-icon>check_circle</mat-icon>
            <span>{{ benefit }}</span>
          </div>
        }
      </div>
      <button class="button-white" (click)="renewSubscription()">
        Rinnova il tuo abbonamento
      </button>
    </div>
  }

  @if (isDeletingAccount) {
    <div class="loading-container">
      <app-loader [size]="'big'"></app-loader>
    </div>
  }
  @if (!isDeletingAccount) {
    <section class="delete-account-section">
      <button mat-button (click)="onDeleteClick()">
        {{ labelService.getLabel("Elimina Account") }}
      </button>
    </section>
  }
</div>
